import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swiperLeftBtn",
  "use": "icon-swiperLeftBtn-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 96 96\" id=\"icon-swiperLeftBtn\">\n<style type=\"text/css\">\n\t#icon-swiperLeftBtn .st0{fill:none;stroke:#202820;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:20;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M62,10L26,48l36,38\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol